(function () {
    'use strict';

    angular.module('components.storage', [
        // angular-local-storage
        'LocalStorageModule'
    ]);
})();